export const apiRoutes = {
  emailAutomation: {
    workers: {
      health: () => 'api/v2/email-automation/workers/health'
    }
  },
  equipment: {
    management: {
      page: () => 'api/v2/equipment/management/page',
      filteredListPost: (page: number, pageSize: number, orderBy?: string, isDesc?: boolean) => {
        let url = `api/v2/equipment/management/filter?page=${page}&pageSize=${pageSize}`;
        if (orderBy !== undefined) url += `&orderBy=${orderBy}`;
        if (isDesc !== undefined) url += `&isDesc=${isDesc}`;
        return url;
      },
      exportCsv: (orderBy?: string, isDesc?: boolean) => {
        let url = 'api/v2/equipment/management/export/csv';
        const queryParams: string[] = [];
        if (orderBy !== undefined) queryParams.push(`orderBy=${encodeURIComponent(orderBy)}`);
        if (isDesc !== undefined) queryParams.push(`isDesc=${isDesc}`);
        if (queryParams.length > 0) url += `?${queryParams.join('&')}`;
        return url;
      },
      create: () => 'api/v2/equipment/management',
      editor: (equipmentId: number) => `api/v2/equipment/management/${equipmentId}`,
      delete: (equipmentId: number) => `api/v2/equipment/management/${equipmentId}`,
      multiDelete: () => 'api/v2/equipment/management/multi-delete',
      batchOwner: () => 'api/v2/equipment/management/batch-owner',
      batchLocation: () => 'api/v2/equipment/management/batch-location',
      batchUser: () => 'api/v2/equipment/management/batch-user',
      batchVerifyUsed: () => 'api/v2/equipment/management/batch-verify-used',
      status: (equipmentId: number) => `api/v2/equipment/management/${equipmentId}/status`,
      verifyUsed: (equipmentId: number) => `api/v2/equipment/management/${equipmentId}/verify-used`,
      documents: (equipmentId: number, documentType: string) =>
        `api/v2/equipment/management/${equipmentId}/documents?documentType=${encodeURIComponent(documentType)}`,
      createDocument: (equipmentId: number) => `api/v2/equipment/management/${equipmentId}/documents`,
      updateDocument: (equipmentId: number, documentId: number) =>
        `api/v2/equipment/management/${equipmentId}/documents/${documentId}`,
      deleteDocument: (equipmentId: number, documentId: number) =>
        `api/v2/equipment/management/${equipmentId}/documents/${documentId}`,
      downloadDocument: (equipmentId: number, documentId: number) =>
        `api/v2/equipment/management/${equipmentId}/documents/${documentId}/download`
    },
    historyReport: {
      page: () => 'api/v2/equipment/history-report/page',
      filteredListPost: (page: number, pageSize: number) =>
        `api/v2/equipment/history-report/filter?page=${page}&pageSize=${pageSize}`,
      exportCsv: () => 'api/v2/equipment/history-report/export/csv',
      detail: (equipmentId: number) => `api/v2/equipment/history-report/${equipmentId}`
    }
  },
  purchaseOrderReport: {
    page: () => 'api/v2/purchasing/purchase-order-report/page',
    filteredListPost: (page: number, pageSize: number) =>
      `api/v2/purchasing/purchase-order-report/filter?page=${page}&pageSize=${pageSize}`,
    exportCsv: () => 'api/v2/purchasing/purchase-order-report/export/csv',
    create: () => 'api/v2/purchasing/purchase-order-report',
    editor: (purchaseOrderId: number) => `api/v2/purchasing/purchase-order-report/${purchaseOrderId}`,
    approvalSeed: (purchaseOrderId: number) => `api/v2/purchasing/purchase-order-report/${purchaseOrderId}/approval`,
    approve: (purchaseOrderId: number) => `api/v2/purchasing/purchase-order-report/${purchaseOrderId}/approval`,
    delete: (purchaseOrderId: number) => `api/v2/purchasing/purchase-order-report/${purchaseOrderId}`
  },
  invoiceNumberReport: {
    page: () => 'api/v2/invoicing/invoice-number-report/page',
    filteredListPost: (page: number, pageSize: number, orderBy?: string, isDesc?: boolean) => {
      let url = `api/v2/invoicing/invoice-number-report/filter?page=${page}&pageSize=${pageSize}`;
      if (orderBy !== undefined) url += `&orderBy=${orderBy}`;
      if (isDesc !== undefined) url += `&isDesc=${isDesc}`;
      return url;
    }
  },
  invoiceApproval: {
    page: () => 'api/v2/invoicing/invoice-approval/page',
    filteredListPost: (page: number, pageSize: number) =>
      `api/v2/invoicing/invoice-approval/filter?page=${page}&pageSize=${pageSize}`,
    approve: (invoiceId: number) => `api/v2/invoicing/invoice-approval/${invoiceId}/approve`,
    reject: (invoiceId: number) => `api/v2/invoicing/invoice-approval/${invoiceId}/reject`,
    unlock: (invoiceId: number) => `api/v2/invoicing/invoice-approval/${invoiceId}/unlock`
  },
  invoiceCodes: {
    page: () => 'api/v2/admin/invoice-codes/page',
    save: () => 'api/v2/admin/invoice-codes',
    systemChargeMapping: () => 'api/v2/admin/invoice-codes/system-charge-mapping'
  },
  mailLists: {
    list: () => 'api/v2/admin/mail-lists',
    update: () => 'api/v2/admin/mail-lists'
  },
  dropdownApplication: {
    page: () => 'api/v2/admin/dropdown-application/page',
    addEntry: () => 'api/v2/admin/dropdown-application/entries',
    deleteEntry: (id: number, type: string, parentId?: number) =>
      `api/v2/admin/dropdown-application/entries/${id}?type=${encodeURIComponent(type)}${
        parentId !== undefined ? `&parentId=${parentId}` : ''
      }`,
    toggleEntry: (id: number) => `api/v2/admin/dropdown-application/entries/${id}/toggle`,
    updateEquipmentLocation: (id: number) => `api/v2/admin/dropdown-application/equipment-locations/${id}`,
    updateJobQuote: (id: number) => `api/v2/admin/dropdown-application/job-quotes/${id}`,
    updateSetting: (id: number) => `api/v2/admin/dropdown-application/settings/${id}`,
    addUserInitial: () => 'api/v2/admin/dropdown-application/user-initials',
    deleteUserInitial: (id: number) => `api/v2/admin/dropdown-application/user-initials/${id}`
  },
  invoices: {
    list: (page: number, pageSize: number) => `api/v2/invoices?page=${page}&pageSize=${pageSize}`,
    get: (invoiceId: number) => `api/v2/invoices/${invoiceId}`,
    changeLog: (invoiceId: number) => `api/v2/invoices/${invoiceId}/change-log`,
    downloadDocument: (invoiceId: number, documentId: number) =>
      `api/v2/invoices/${invoiceId}/documents/${documentId}/download`,
    documentPackage: (invoiceId: number) => `api/v2/invoices/${invoiceId}/documents/package`,
    listForJob: (jobId: number) => `api/v2/jobs/${jobId}/invoices`,
    createLineItem: (invoiceId: number) => `api/v2/invoices/${invoiceId}/line-items`,
    delete: (invoiceId: number) => `api/v2/invoices/${invoiceId}`,
    deleteLineItem: (invoiceId: number, lineItemId: number) => `api/v2/invoices/${invoiceId}/line-items/${lineItemId}`,
    regenerate: (invoiceId: number) => `api/v2/invoices/${invoiceId}/regenerate`,
    recall: (invoiceId: number) => `api/v2/invoices/${invoiceId}/recall`,
    resetLineItemToAuto: (invoiceId: number, lineItemId: number) =>
      `api/v2/invoices/${invoiceId}/line-items/${lineItemId}/reset-to-auto`,
    submit: (invoiceId: number) => `api/v2/invoices/${invoiceId}/submit`,
    unlock: (invoiceId: number) => `api/v2/invoices/${invoiceId}/unlock`,
    updateHeader: (invoiceId: number) => `api/v2/invoices/${invoiceId}/header`,
    updateLineItem: (invoiceId: number, lineItemId: number) => `api/v2/invoices/${invoiceId}/line-items/${lineItemId}`,
    updateSnapshotIncludeTax: (invoiceId: number, snapshotId: number) =>
      `api/v2/invoices/${invoiceId}/snapshots/${snapshotId}/include-tax`
  },
  invoiceRulesEngineV2: {
    list: (search?: string) =>
      search && search.trim().length > 0
        ? `api/v2/invoicing/rulesets?search=${encodeURIComponent(search.trim())}`
        : 'api/v2/invoicing/rulesets',
    detail: (id: number) => `api/v2/invoicing/rulesets/${id}`,
    create: () => 'api/v2/invoicing/rulesets',
    update: (id: number) => `api/v2/invoicing/rulesets/${id}`,
    delete: (id: number) => `api/v2/invoicing/rulesets/${id}`,
    replaceCompanies: (id: number) => `api/v2/invoicing/rulesets/${id}/companies`,
    clientCompanies: () => 'api/v2/invoicing/rulesets/client-companies',
    invoiceCodes: () => 'api/v2/invoicing/rulesets/invoice-codes',
    rules: {
      create: (rulesetId: number) => `api/v2/invoicing/rulesets/${rulesetId}/rules`,
      update: (rulesetId: number, ruleId: number) => `api/v2/invoicing/rulesets/${rulesetId}/rules/${ruleId}`,
      delete: (rulesetId: number, ruleId: number) => `api/v2/invoicing/rulesets/${rulesetId}/rules/${ruleId}`,
      reorder: (rulesetId: number, ruleId: number) => `api/v2/invoicing/rulesets/${rulesetId}/rules/${ruleId}/order`
    }
  },
  timesheetSummaryReport: {
    page: (fieldTimeOnly: boolean) => `api/v2/reporting/timesheet-summary/page?fieldTimeOnly=${fieldTimeOnly}`,
    filteredListPost: (page: number, pageSize: number) =>
      `api/v2/reporting/timesheet-summary/filter?page=${page}&pageSize=${pageSize}`,
    exportCsv: () => 'api/v2/reporting/timesheet-summary/export/csv',
    summaryPdf: () => 'api/v2/reporting/timesheet-summary/summary-pdf',
    timesheetsPdf: () => 'api/v2/reporting/timesheet-summary/timesheets-pdf'
  },
  equipmentUsageReport: {
    page: () => 'api/v2/reporting/equipment-usage-report/page',
    table: () => 'api/v2/reporting/equipment-usage-report/table'
  },
  jobStatusReport: {
    exportCsv: () => 'api/v2/reporting/job-status-report/export/csv',
    page: () => 'api/v2/reporting/job-status-report/page',
    table: () => 'api/v2/reporting/job-status-report/table',
    recalculate: (jobId: number) => `api/v2/reporting/job-status-report/${jobId}/recalculate`
  },
  safetyTicketReport: {
    page: () => 'api/v2/safety/safety-ticket-report/page',
    filteredListPost: (page: number, pageSize: number) =>
      `api/v2/safety/safety-ticket-report/filter?page=${page}&pageSize=${pageSize}`,
    exportCsv: () => 'api/v2/safety/safety-ticket-report/export/csv'
  },
  dailySafety: {
    combinedReportPdfs: (queryString: string) => `DailySafetyTickets/GetCombinedReportPdfs${queryString}`
  },
  quickLinks: {
    list: (showInNavOnly?: boolean) => `api/v2/quick-links${showInNavOnly === true ? '?showInNavOnly=true' : ''}`,
    create: () => 'api/v2/quick-links',
    update: (quickLinkId: number) => `api/v2/quick-links/${quickLinkId}`,
    delete: (quickLinkId: number) => `api/v2/quick-links/${quickLinkId}`,
    download: (quickLinkId: number) => `api/v2/quick-links/${quickLinkId}/download`,
    navigation: () => 'api/v2/quick-links?showInNavOnly=true'
  },
  jobs: {
    search: (term: string) => `api/JobSearch/search?term=${encodeURIComponent(term)}`
  },
  jobBook: {
    page: () => 'api/v2/jobs',
    year: (year: number) => `api/v2/jobs/year/${year}`,
    filter: (orderBy?: string, isDesc?: boolean) => {
      let url = 'api/v2/jobs/filter';
      const queryParams: string[] = [];
      if (orderBy !== undefined) queryParams.push(`orderBy=${encodeURIComponent(orderBy)}`);
      if (isDesc !== undefined) queryParams.push(`isDesc=${isDesc}`);
      if (queryParams.length > 0) url += `?${queryParams.join('&')}`;
      return url;
    },
    delete: (jobId: number) => `api/v2/jobs/${jobId}`,
    location: {
      create: () => 'api/v2/jobs/location',
      delete: (locationId: number) => `api/v2/jobs/location/${locationId}`,
      get: (locationId: number) => `api/v2/jobs/location/${locationId}`,
      upload: () => 'api/v2/jobs/location/upload'
    },
    editor: {
      page: (query: string) => `api/v2/jobs/editor?${query}`,
      save: () => 'api/v2/jobs/editor/save',
      lock: () => 'api/v2/jobs/editor/lock',
      copy: (copies: number) => `api/v2/jobs/editor/copy?copies=${copies}`,
      revise: () => 'api/v2/jobs/editor/revise',
      reviseOpenJobsCheck: (compassId: number, jobYear: number) =>
        `api/v2/jobs/editor/revise/open-jobs-check?compassId=${compassId}&jobYear=${jobYear}`,
      locationJobSearch: () => 'api/v2/jobs/editor/locations/job-search',
      cascade: {
        jobSubTypes: (jobTypeId: number) => `api/v2/jobs/editor/cascade/jobSubTypes?jobTypeId=${jobTypeId}`,
        jobActivities: (jobTypeId: number) => `api/v2/jobs/editor/cascade/jobActivities?jobTypeId=${jobTypeId}`,
        clientManagers: (clientId: number) => `api/v2/jobs/editor/cascade/clientManagers?clientId=${clientId}`,
        clientInvoicingFields: (clientId: number) =>
          `api/v2/jobs/editor/cascade/clientInvoicingFields?clientId=${clientId}`,
        primaryContact: (clientId: number) => `api/v2/jobs/editor/cascade/primaryContact?clientId=${clientId}`,
        clientContactInfo: (contactId: number) => `api/v2/jobs/editor/cascade/clientContactInfo?contactId=${contactId}`
      }
    },
    workspace: {
      invoices: (jobId: number) => `api/v2/jobs/${jobId}/workspace/invoices`,
      invoiceGenerationOptions: (jobId: number) => `api/v2/jobs/${jobId}/workspace/invoices/generation-options`,
      generateInvoice: (jobId: number) => `api/v2/jobs/${jobId}/workspace/invoices/generate`,
      timeSummary: (jobId: number) => `api/v2/jobs/${jobId}/workspace/time-summary`,
      timeSummaryExportCsv: (jobId: number) => `api/v2/jobs/${jobId}/workspace/time-summary/export/csv`,
      timeSummaryTransfer: (jobId: number) => `api/v2/jobs/${jobId}/workspace/time-summary/transfer`,
      history: (jobId: number) => `api/v2/jobs/${jobId}/workspace/history`,
      purchases: (jobId: number) => `api/v2/jobs/${jobId}/workspace/purchases`,
      purchaseVendors: (jobId: number) => `api/v2/jobs/${jobId}/workspace/purchases/vendors`,
      purchaseDelete: (jobId: number, purchaseId: number) => `api/v2/jobs/${jobId}/workspace/purchases/${purchaseId}`,
      purchaseSave: (jobId: number) => `api/v2/jobs/${jobId}/workspace/purchases`,
      purchaseTransfer: (jobId: number) => `api/v2/jobs/${jobId}/workspace/purchases/transfer`,
      files: (jobId: number) => `api/v2/jobs/${jobId}/workspace/files`,
      fileDownload: (jobId: number, fileName: string) =>
        `api/v2/jobs/${jobId}/workspace/files/download?fileName=${encodeURIComponent(fileName)}`,
      fileDelete: (jobId: number, fileName: string) =>
        `api/v2/jobs/${jobId}/workspace/files?fileName=${encodeURIComponent(fileName)}`,
      fileUpload: (jobId: number) => `api/v2/jobs/${jobId}/workspace/files`
    },
    selectOptions: {
      contacts: (companyId: number) => `api/v2/jobs/selectOptions/contacts?companyId=${companyId}`,
      jobSubTypes: (jobTypeIds: number[]) =>
        `api/v2/jobs/selectOptions/jobSubTypes?${jobTypeIds.map((id) => `jobTypeIds=${id}`).join('&')}`,
      locationTypes: (jobTypeIds: number[]) =>
        `api/v2/jobs/selectOptions/locationTypes?${jobTypeIds.map((id) => `jobTypeIds=${id}`).join('&')}`,
      locationSubTypes: (locationType: string) =>
        `api/v2/jobs/selectOptions/locationSubTypes?locationType=${encodeURIComponent(locationType)}`
    }
  },
  userManagement: {
    filteredListPost: (page: number, pageSize: number, orderBy?: string, isDesc?: boolean) => {
      let url = `api/admin/userManagement/filter?page=${page}&pageSize=${pageSize}`;
      if (orderBy !== undefined) url += `&orderBy=${orderBy}`;
      if (isDesc !== undefined) url += `&isDesc=${isDesc}`;
      return url;
    },
    getBasicInfo: (userId: string) => `api/admin/userManagement/${userId}/basicInfo`,
    updateBasicInfo: (userId: string) => `api/admin/userManagement/${userId}/basicInfo`,
    create: () => `api/admin/userManagement/create`,
    activities: (userId: string) => `api/admin/userManagement/${userId}/activities`,
    emergencyContacts: (userId: string) => `api/admin/userManagement/${userId}/emergencyContacts`,
    deleteEmergencyContact: (userId: string, contactId: number) =>
      `api/admin/userManagement/${userId}/emergencyContacts/${contactId}`,
    safetyTickets: (userId: string) => `api/admin/userManagement/${userId}/safetyTickets`,
    removeSafetyTicket: (userId: string, ticketId: number) =>
      `api/admin/userManagement/${userId}/safetyTickets/${ticketId}`,
    updateSafetyTicketExpiry: (userId: string, ticketId: number) =>
      `api/admin/userManagement/${userId}/safetyTickets/${ticketId}/expiry`,
    safetyTicketDocuments: (userId: string) => `api/admin/userManagement/${userId}/safetyTicketDocuments`,
    downloadSafetyTicketDocument: (userId: string, fileName: string) =>
      `api/admin/userManagement/${userId}/safetyTicketDocuments/download?fileName=${encodeURIComponent(fileName)}`,
    deleteSafetyTicketDocument: (userId: string, fileName: string) =>
      `api/admin/userManagement/${userId}/safetyTicketDocuments?fileName=${encodeURIComponent(fileName)}`,
    bankTime: (userId: string) => `api/admin/userManagement/${userId}/bankTime`,
    replacement: (userId: string) => `api/admin/userManagement/${userId}/replacement`,
    replacementOptions: (userId: string) => `api/admin/userManagement/${userId}/replacementOptions`
  },
  hrManagement: {
    verifyPassword: () => 'api/v2/hr/verify-password',
    users: () => 'api/v2/hr/users',
    reminders: (userId: string) => `api/v2/hr/users/${userId}/reminders`,
    reminder: (userId: string, reminderId: number) => `api/v2/hr/users/${userId}/reminders/${reminderId}`,
    notes: (userId: string) => `api/v2/hr/users/${userId}/notes`,
    note: (userId: string, noteId: number) => `api/v2/hr/users/${userId}/notes/${noteId}`,
    documents: (userId: string, documentType: string) =>
      `api/v2/hr/users/${userId}/documents?documentType=${encodeURIComponent(documentType)}`,
    createDocument: (userId: string) => `api/v2/hr/users/${userId}/documents`,
    updateDocument: (userId: string, documentId: number) => `api/v2/hr/users/${userId}/documents/${documentId}`,
    deleteDocument: (userId: string, documentId: number) => `api/v2/hr/users/${userId}/documents/${documentId}`,
    downloadDocument: (userId: string, documentId: number) =>
      `api/v2/hr/users/${userId}/documents/${documentId}/download`
  },
  companyCrm: {
    filteredListPost: (page: number, pageSize: number, orderBy?: string, isDesc?: boolean) => {
      let url = `api/v2/crm/companies/filter?page=${page}&pageSize=${pageSize}`;
      if (orderBy !== undefined) url += `&orderBy=${orderBy}`;
      if (isDesc !== undefined) url += `&isDesc=${isDesc}`;
      return url;
    },
    exportExcel: (orderBy?: string, isDesc?: boolean) => {
      let url = 'api/v2/crm/companies/export/excel';
      const queryParams: string[] = [];
      if (orderBy !== undefined) queryParams.push(`orderBy=${encodeURIComponent(orderBy)}`);
      if (isDesc !== undefined) queryParams.push(`isDesc=${isDesc}`);
      if (queryParams.length > 0) url += `?${queryParams.join('&')}`;
      return url;
    },
    delete: (companyId: number) => `api/v2/crm/companies/${companyId}`,
    getBasicInfo: (companyId: number) => `api/v2/crm/companies/${companyId}/basicInfo`,
    updateBasicInfo: (companyId: number) => `api/v2/crm/companies/${companyId}/basicInfo`,
    create: () => 'api/v2/crm/companies',
    contacts: (companyId: number) => `api/v2/crm/companies/${companyId}/contacts`,
    exportContactsExcel: (companyId: number) => `api/v2/crm/companies/${companyId}/contacts/export/excel`,
    updateContact: (companyId: number, contactId: number) => `api/v2/crm/companies/${companyId}/contacts/${contactId}`,
    deleteContact: (companyId: number, contactId: number) => `api/v2/crm/companies/${companyId}/contacts/${contactId}`,
    documents: (companyId: number, documentType: string) =>
      `api/v2/crm/companies/${companyId}/documents?documentType=${encodeURIComponent(documentType)}`,
    createDocument: (companyId: number) => `api/v2/crm/companies/${companyId}/documents`,
    updateDocument: (companyId: number, documentId: number) =>
      `api/v2/crm/companies/${companyId}/documents/${documentId}`,
    deleteDocument: (companyId: number, documentId: number) =>
      `api/v2/crm/companies/${companyId}/documents/${documentId}`,
    downloadDocument: (companyId: number, documentId: number) =>
      `api/v2/crm/companies/${companyId}/documents/${documentId}/download`,
    notes: (companyId: number, companyContactId?: number, auditOnly = false) => {
      const queryParams = [];
      if (companyContactId !== undefined) queryParams.push(`companyContactId=${companyContactId}`);
      if (auditOnly) queryParams.push('auditOnly=true');
      return `api/v2/crm/companies/${companyId}/notes${queryParams.length > 0 ? `?${queryParams.join('&')}` : ''}`;
    },
    deleteNote: (companyId: number, noteId: number) => `api/v2/crm/companies/${companyId}/notes/${noteId}`,
    updateNote: (companyId: number, noteId: number) => `api/v2/crm/companies/${companyId}/notes/${noteId}`,
    selectOptions: {
      users: () => 'api/v2/crm/companies/selectOptions/users',
      provinces: () => 'api/v2/crm/companies/selectOptions/provinces',
      invoiceTemplates: () => 'api/v2/crm/companies/selectOptions/invoiceTemplates',
      companyTypes: () => 'api/v2/crm/companies/selectOptions/companyTypes',
      companySubTypes: () => 'api/v2/crm/companies/selectOptions/companySubTypes',
      cities: () => 'api/v2/crm/companies/selectOptions/cities',
      lineOfBusinesses: () => 'api/v2/crm/companies/selectOptions/lineOfBusinesses',
      invoiceRulesets: () => 'api/v2/crm/companies/selectOptions/invoiceRulesets'
    }
  },
  util: {
    selectOption: {
      enumType: (type: string) => `/selectOption/enum/${type}`,
      users: () => `/selectoption/users`,
      departments: () => `/selectoption/departments`,
      workLocations: () => `/selectoption/workLocations`,
      provinces: () => `/selectoption/provinces`,
      officeTimeActivities: () => `/selectoption/officeTimeActivities`,
      fieldTimeTypes: () => `/selectoption/fieldTimeTypes`,
      safetyTicketItems: () => `/selectoption/safetyTicketItems`,
      usersInRoles: (roles: string[]) => {
        let toReturn = `/selectoption/UsersInRoles`;
        roles.forEach((role) => {
          if (toReturn.indexOf('?') >= 0) {
            toReturn += `&roles=${role}`;
          } else {
            toReturn += `?roles=${role}`;
          }
        });
        return toReturn;
      }
    }
  },
  rateSheets: {
    filteredListPost: (page: number, pageSize: number, orderBy?: string, isDesc?: boolean) => {
      let url = `api/v2/rateSheets/filter?page=${page}&pageSize=${pageSize}`;
      if (orderBy !== undefined) url += `&orderBy=${orderBy}`;
      if (isDesc !== undefined) url += `&isDesc=${isDesc}`;
      return url;
    },
    getDetail: (id: number) => `api/v2/rateSheets/${id}`,
    save: () => `api/v2/rateSheets/save`,
    delete: (id: number) => `api/v2/rateSheets/${id}`,
    lookups: () => `api/v2/rateSheets/lookups`,
    selectOptions: {
      companies: () => `api/v2/rateSheets/selectOptions/companies`
    }
  }
};
